import { SET_ACTIVE_LANG } from '../actions/setActiveLangAction';
import { SET_STATIC_DEFAULT_CONTENT } from '../actions/setStaticDefaultContentAction';
import { SET_STATIC_ACTIVE_LANG_CONTENT } from '../actions/setStaticActiveLangContentAction';

const initialState = {
    activeLang: localStorage.getItem('activeLang') || 'uk',
    defaultStaticContent: {},
    activeLangStaticContent: {},
  };

export function langReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACTIVE_LANG: {
            return {...state, activeLang: action.iso}
        }
        case SET_STATIC_DEFAULT_CONTENT: {
            return {
                ...state, 
                defaultStaticContent: action.value,
                ...(action.additionalValue && {activeLangStaticContent: action.additionalValue})
            }
        }
        case SET_STATIC_ACTIVE_LANG_CONTENT: {
            if (state.activeLang !== 'uk') {
                return {...state, activeLangStaticContent: action.value}
            } else {
                return {...state, activeLangStaticContent: {}, defaultStaticContent: action.value}
            }
        }
        default:
        return state;
    }
}